export const messageRecipientsTableFrag = `
    id
    userId
    messageId
    readAt
    user {
        id
        name
        surname
        titleBeforeName
        titleAfterName
        image
        organizations {
            id
            organization {
                name
            }
        }
    }
`;
